import React from 'react';
import { Query, Mutation } from 'react-apollo';
import gql from 'graphql-tag';
import { CircularProgress, Box } from '@material-ui/core';
import SequenceList from '../../components/EmailPlatform/SequenceList';
import { withSnackbar } from 'notistack';

const GET_EMAIL_SEQUENCES = gql`
  query GetEmailSequences {
    emailSequences {
      id
      name
      description
      category
      active
      status
      createdAt
      enrollmentCount
      activeEnrollmentCount
      sequence_tag_list
      steps {
        id
        position
      }
    }
  }
`;

const UPDATE_SEQUENCE_ACTIVE = gql`
  mutation UpdateEmailSequence($id: ID!, $active: Boolean) {
    update_email_sequence(id: $id, active: $active) {
      emailSequence {
        id
        active
      }
      errors
    }
  }
`;

const DELETE_SEQUENCE = gql`
  mutation DeleteEmailSequence($id: ID!) {
    delete_email_sequence(id: $id) {
      success
      errors
    }
  }
`;

class SequenceListContainer extends React.Component {
  handleToggleActive = (updateSequence, refetch) => (sequenceId, newActiveState) => {
    updateSequence({
      variables: {
        id: sequenceId,
        active: newActiveState,
      },
    })
      .then(({ data }) => {
        if (data.update_email_sequence.errors && data.update_email_sequence.errors.length > 0) {
          this.props.enqueueSnackbar(`Error: ${data.update_email_sequence.errors.join(', ')}`, {
            variant: 'error',
          });
        } else {
          this.props.enqueueSnackbar(
            newActiveState ? 'Sequence activated' : 'Sequence deactivated',
            { variant: 'success' }
          );
          refetch();
        }
      })
      .catch(error => {
        this.props.enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
      });
  };

  handleDelete = (deleteSequence, refetch) => (sequenceId) => {
    deleteSequence({
      variables: { id: sequenceId },
    })
      .then(({ data }) => {
        if (data.delete_email_sequence.errors && data.delete_email_sequence.errors.length > 0) {
          this.props.enqueueSnackbar(`Error: ${data.delete_email_sequence.errors.join(', ')}`, {
            variant: 'error',
          });
        } else {
          this.props.enqueueSnackbar('Sequence deleted successfully', { variant: 'success' });
          refetch();
        }
      })
      .catch(error => {
        this.props.enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
      });
  };

  render() {
    return (
      <Query query={GET_EMAIL_SEQUENCES}>
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return (
              <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
                <CircularProgress />
              </Box>
            );
          }

          if (error) {
            return <div>Error loading sequences: {error.message}</div>;
          }

          const sequences = (data.emailSequences || []).map(seq => ({
            ...seq,
            emailSequenceSteps: seq.steps, // Map steps to emailSequenceSteps for component compatibility
          }));

          return (
            <>
              <Mutation mutation={UPDATE_SEQUENCE_ACTIVE}>
                {(updateSequence) => (
                  <Mutation mutation={DELETE_SEQUENCE}>
                    {(deleteSequence) => (
                      <SequenceList
                        sequences={sequences}
                        onToggleActive={this.handleToggleActive(updateSequence, refetch)}
                        onDelete={this.handleDelete(deleteSequence, refetch)}
                        onRefresh={refetch}
                      />
                    )}
                  </Mutation>
                )}
              </Mutation>
            </>
          );
        }}
      </Query>
    );
  }
}

export default withSnackbar(SequenceListContainer);

